<template lang="pug">
section.payment
  .callout.callout-info(v-if="!$store.state.user.hide_change_label")
    p
      | {{$store.state.user.plan_to_change.display_name}}プランに変更します。
  alert-error(v-if="error",:msg="error_msg")
  #creditcard
    p ご利用可能なクレジットカード
    i.fab.fa-cc-visa
    i.fab.fa-cc-mastercard
    i.fab.fa-cc-amex
    i.fab.fa-cc-jcb
    i.fab.fa-cc-diners-club
    i.fab.fa-cc-discover

    .form-group.mt-4
      label(for='coupon_code') クーポンコード
      .input-group
        input#coupon_code.form-control(type='text',
        v-model="coupon_code",
        name='coupon_code',
        placeholder='クーポンコードを入力')
      .text-xs.mt-1(v-if="coupon_code") ※クーポンコードは決済時に適用されます。

    .form-group.mt-4
      template(v-if="$store.state.user.submitting_card")
        button.btn.btn-primary.btn-block(disabled="disabled")
          i.fa.fa-spinner.fa-spin
          | 送信中です...
      template(v-else)
        button.btn.btn-primary.btn-block(@click="redirectToStripeCheckout") カード登録を開始する
      a.btn.btn-block.btn-back-to-signup.mt-2(v-if="show_back_button", :href="back_url") 申込内容に戻る
    .text-muted.text-xs.mt-3
      | ※SiteLeadは、最も厳しい業界標準に準拠した
      a(href="https://stripe.com/jp", target="_blank") Stripe
      | という決済システムを利用しております。
      br/
      | ご入力いただいたクレジットカード情報は、SiteLeadを経由せずStripeに登録され、当社含む第三者が閲覧、把握することはできません。
</template>

<script>
import Vue from 'vue'

import AlertError from '../components/parts/error.vue'

export default {
  data(){
    return {
      stripe: "",
      error_msg: "",
      error: false,
      coupon_code: ""
    }
  },
  props: {
    stripe_key: String,
    show_back_button: { type: Boolean, default: false },
    back_url: { type: String, default: '' },
  },
  computed: {
    couponName() {
      return this.$store.state.user.coupon_name
    },
    planName() {
      return this.$store.state.user.plan_to_change?.name;
    },
  },
  methods: {
    redirectToStripeCheckout() {
      this.$store.commit("user/onSubmittingCard")
      this.error = false

      try {
        const planId = this.$store.state.user.plan_to_change?.id || this.$store.state.user.plan_id
        let url = `/users/stripes/create_checkout_session?plan_id=${planId}`

        if (this.coupon_code) {
          url += `&coupon_code=${encodeURIComponent(this.coupon_code)}`
        }

        window.location.href = url
      } catch (e) {
        this.error = true
        this.error_msg = e.message
        this.$store.commit("user/offSubmittingCard")
      }
    }
  },
  components:{
    AlertError
  },
  async mounted(){
    await Vue.nextTick()
    this.stripe = Stripe(this.stripe_key)
    this.$store.commit("user/setStripeKey", this.stripe_key)
  }
}
</script>
<style lang="scss" scoped>
.alert{
  p{
    margin-bottom: 0px;
  }
}
button{
  i.fa{
    margin-right:0.5rem;
  }
}
.btn-back-to-signup {
  background-color: #5F5F5F;
  color: #fff;
}
.btn-back-to-signup:hover,
.btn-back-to-signup:focus,
.btn-back-to-signup:visited {
  background-color: #5F5F5F;
  color: #fff;
}
</style>
